module.exports = __webpack_public_path__ + "img/alerta_3.9f4d8ef6.png";